import { addDoc, collection, getDocs, updateDoc } from "@firebase/firestore";
import { titleMatchesIngredient } from "./post";

// eslint-disable-next-line import/prefer-default-export
export async function fetchPantry(user, db) {
  const pantryRef = collection(db, 'users', user.currentUser.uid, 'pantries');
  const pantrySnapshot = getDocs(pantryRef);
  return pantrySnapshot;
}

export async function fetchPantryWithId(user, db) {
  const pantryRef = collection(db, 'users', user.currentUser.uid, 'pantries');
  const pantrySnapshot = await getDocs(pantryRef);
  const pantry = [];
  pantrySnapshot.forEach((doc) => {
    pantry.push({ id: doc.id, ...doc.data() });
  });
  return pantry;
}

export async function updatePantryItem(db, userId, pantryId, newPantryItem) {
  const pantryRef = collection(db, 'users', userId, 'pantries', pantryId);
  await updateDoc(pantryRef, newPantryItem);

}

export async function addPantryItem(db, userId, newPantryItem) {
  const pantryRef = collection(db, 'users', userId, 'pantries');
  await addDoc(pantryRef, newPantryItem);
}

export function findPantryWithIngredient(ingredient, pantry) {
  const matchingIngredient = pantry.find((pantryItem) =>
    titleMatchesIngredient(pantryItem.pantryFoodTitle, ingredient.ingredientText));
  return matchingIngredient || null;
}